module.exports = __webpack_public_path__ + "static/media/store.79ab70ec.svg";